import { render, staticRenderFns } from "./VuesticMultiSelect.vue?vue&type=template&id=3b712998&scoped=true&"
import script from "./VuesticMultiSelect.vue?vue&type=script&lang=js&"
export * from "./VuesticMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./VuesticMultiSelect.vue?vue&type=style&index=0&id=3b712998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b712998",
  null
  
)

component.options.__file = "VuesticMultiSelect.vue"
export default component.exports